import React, { useState } from "react";
import OutsideClick from "../onOutSideClick/OutSideClick";
import Button from "../Button/Button";
import { getUserRightsDetails } from "../../../Store/UserRights/UserRights.action";
import Navdropdown from "../NavbarbuttonDropDown/Navdropdown";
import "./Navbar.scss";
const Sidebar = ({ userRights, isOpen, closeSidebar }) => {

  const [nav, setnav] = useState("");
  const [toggleDropDown, settoggle] = useState(false);
  // console.log({ nav, toggleDropDown, isOpen }, "displaynonedisplaynone")
  const closeAllDropdowns = () => {
    settoggle(false);
    setnav("");
  };
  const handleNavButtonClick = (menuName, event) => {
    event.stopPropagation(); // Prevents the click from propagating to parent elements
    setnav(menuName);
    settoggle(!toggleDropDown);
  };
  return (
    <div className="sidebarcontainer">
      <OutsideClick setToggled={closeSidebar}>
        <div className={`sidebar ${isOpen ? "open" : ""}`}>
          <div>
            {userRights?.map((e, index) => (
              <div key={index} className="sidebar-item">
                <Button
                  name="navbutton"
                  text={e.Menu_Name}
                  action={(event) => handleNavButtonClick(e.Menu_Name, event)}
                />
                <Navdropdown
                  display={toggleDropDown && nav === e.Menu_Name}
                  name={nav}
                  content={e.Modules.length > 0 ? e.Modules : ""}
                  onClose={closeAllDropdowns}
                />
              </div>
            ))}
          </div>
        </div>
      </OutsideClick>
    </div>
  );
};

export default Sidebar;
